const NS = 'WoolMarketWeeklyReportsPage';
const CLS = 'woolMarketWeeklyReportsPage';

export class WoolMarketWeeklyReportsPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.initTogglerEvent();

		this.yearsApi = this.$element.attr('data-years-api');
		this.weeksApi = this.$element.attr('data-weeks-api');

		this.$selectYears = this.$element.find(`select.${CLS}-filters-select--years`);
		this.$selectWeeks = this.$element.find(`select.${CLS}-filters-select--weeks`);
		this.$selectWeeks.attr('disabled', true); // Disable the selectWeeks onload

		this.loadYears();
	}

	initTogglerEvent() {
		this.$toggler = this.$element.find(`.${CLS}-toggler`);
		this.$tabContent = this.$element.find(`.${CLS}-tabContent`);
		this.$activeToggler = this.$toggler.last(); // Last tab is active onload

		this.$toggler.on('click', (event) => {
			showTab($(event.currentTarget));
		});

		let showTab = ($tab) => {
			if(this.$activeToggler && this.$activeToggler.length > 0) {
				this.$activeToggler.removeClass('active');
			}

			let dataContentType = $tab.attr('data-content-type');
			this.$tabContent.removeClass('active');
			this.$tabContent.filter(`[data-content-type=${dataContentType}]`).addClass('active');

			this.$activeToggler = $tab;
			this.$activeToggler.addClass('active');
		};

		showTab(this.$activeToggler);
	}

	loadYears() {
		$.ajax({
			type: 'GET',
			url: this.yearsApi,
			success: (response) => {
				this.$selectYears.append(() => {
					let markup = '<option value="" class="d-none"></option>';
					response.forEach((item) => {
						markup += `<option value="${item.value}">${item.displayText}</option>`;
					});
					return markup;
				});

				setTimeout(() => {
					this.$selectYears.selectpicker('refresh');
					this.$selectYears.selectpicker('render');
				}, 500);
			},
			error: () => {
				console.error(`${NS}::Error`, 'Could not load the list of years');
			}
		});

		this.$selectYears.on('changed.bs.select', (event, _clickedIndex, _newValue, _oldValue) => {
			let value = $(event.currentTarget).selectpicker().val();
			if(!_.isNil(value)) {
				this.$selectWeeks.attr('disabled', false);
				this.loadWeeks({
					yearId: value
				});
			}
			else {
				this.$selectWeeks.attr('disabled', true);
			}
		});

		this.$selectWeeks.on('changed.bs.select', (event, clickedIndex, _newValue, _oldValue) => {
			let $select = $(event.currentTarget);
			let initialValue = $select.attr('data-initial-value');
			let value = $(event.currentTarget).selectpicker().val();
			if(initialValue !== value && !_.isNil(value)) {
				let $option = $select.find('option').eq(clickedIndex);
				let url = $option.attr('data-url');
				window.location = window.location.origin + url;
			}
		});
	}

	loadWeeks(params) {
		let url = this.weeksApi;

		if(!_.isEmpty(params)) {
			url += `?${$.param(params)}`;
		}
		this.$selectWeeks.empty();

		$.ajax({
			type: 'GET',
			url: url,
			success: (response) => {
				this.$selectWeeks.append(() => {
					let markup = '<option value="" class="d-none"></option>';
					response.forEach((item) => {
						markup += `<option value="${item.weekID}" data-url="${item.url}">${item.displayText}</option>`;
					});
					return markup;
				});

				setTimeout(() => {
					let value = this.$selectWeeks.attr('data-value');
					this.$selectWeeks.selectpicker('val', value);
					this.$selectWeeks.selectpicker('refresh');
					this.$selectWeeks.selectpicker('render');
				}, 500);
			},
			error: () => {
				console.error(`${NS}::Error`, 'Could not load the list of weeks');
			}
		});
	}
}
